import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router, ActivatedRoute } from "@angular/router";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { ApiIntegration } from '../../_services/api.integration';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
@Component({
  selector: 'app-amazon-user-create',
  templateUrl: './amazon-user-create.component.html',
  styleUrls: ['./amazon-user-create.component.css']
})
export class AmazonUserCreateComponent implements OnInit {
  selectedId: string;

  constructor(private alertService: AlertService, private api: ApiIntegration, public user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, public g: Globals) {
    this.g.page = "Create Store Management";
    this.selectedId = this.route.snapshot.params['id']
  }

  ngOnInit() { }
}
